import actions from './actions';
import selectors from './selectors';
import reducer from './reducer';
import sagas from './sagas';

export { actions, sagas, reducer, selectors };
const serviceWorkerModule = { actions, sagas, reducer, selectors };

export default serviceWorkerModule;
